import React from 'react';
import { useNavigate } from 'react-router-dom'; // removed Link

function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="auth-page">
            <div className="auth-card" style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔍</div>
                
                <h1 style={{ 
                    fontSize: '80px', 
                    fontWeight: '700', 
                    letterSpacing: '-0.05em',
                    margin: '0',
                    lineHeight: '1',
                    background: 'linear-gradient(180deg, #FFFFFF 30%, #555555 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>
                    404
                </h1>
                
                <h2 className="auth-title" style={{ marginTop: '16px', marginBottom: '8px' }}>
                    Page Not Found
                </h2>
                
                <p className="auth-subtitle" style={{ marginBottom: '32px' }}>
                    The page you're looking for doesn't exist or has been moved.
                </p>
                
                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button onClick={() => navigate(-1)} className="btn-secondary" style={{ flex: 1, minWidth: '140px' }}>
                        ← Go Back
                    </button>
                    <button onClick={() => navigate('/')} className="btn-primary" style={{ flex: 1, minWidth: '140px' }}>
                        Go Home
                    </button>
                </div>
            </div>
        </div>
    );
}

export default NotFound;